import React from 'react';

interface Props {
  layerSource: string;
  setLayerSource: Function;
}

const XYZLayer: React.FC<Props> = ({ layerSource, setLayerSource }: Props) => {
  layerSource = layerSource || '';

  return (
    <div data-testid="xyz-layer" className="layer-type-form">
      <div className="layer-source clearfix">
        <label htmlFor="layer_source" className="required">URL</label>
        <div className="input">
          <input
            type="text"
            name="layer[source]"
            id="layer_source"
            value={layerSource}
            onChange={(e) => setLayerSource(e.target.value)}
            className="span6"
          />
        </div>
        <span className="helper">
          URL should contain
          {' '}
          <code>{'{z}'}</code>
          ,
          {' '}
          <code>{'{x}'}</code>
          , and
          {' '}
          <code>{'{y}'}</code>
        </span>
      </div>
    </div>
  );
};

export default XYZLayer;
